/*
 * This file is part of the Akershus Eiendom Nettsted 2019 application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import paperPlane1x from 'gfx/paper-plane.png';
import paperPlane2x from 'gfx/paper-plane-2x.png';
import './Image.scss';

/**
 * This is the Image component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function Image(props) {
  return (
    <div className="newsletter-image animate">
      <div className="image animate-1">
        <div>
          <img {...props} />
        </div>
      </div>
      <div className="image decor-plane fly-2">
        <div>
          <img
            srcSet={`${paperPlane1x} 452w, ${paperPlane2x} 904w`}
            sizes="440px"
            alt=""
            role="presentation"
          />
        </div>
      </div>
    </div>
  );
}

export default Image;
